import React, { Component } from 'react';
import '../../../styles/global.scss';
import UnitChart from "./unit-chart";
import * as moment from "moment";
import {createLineDataSetFrom} from "../../../helpers/chart-dataset-helpers";
import PropTypes from "prop-types";
import {UtilityColors} from "../constants/chart-color-constants";
import { withRouter } from 'react-router-dom';


/**
 * Conventional chart for showing monthly units from data, i.e show total consumption for every utility over each month
 * @extends Component
 */
class MonthlyUnitLineChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            labels: this.generateLabels(),
            datasets: this.generateConsumptionDataset(),
            options: this.generateConsumptionOptions(),
            initialSetupDone: false ,
            isNavigating: false // Added to manage navigation state
        };
    }

    componentDidUpdate(prevProps) {
        // Check if data or units prop has changed
        if (this.props.data !== prevProps.data || this.props.units !== prevProps.units) {
            this.setState({
                labels: this.generateLabels(),
                datasets: this.generateConsumptionDataset(),
                initialSetupDone: false // Reset the flag on data or units change
                // options: this.generateConsumptionOptions() // Assuming options do not depend on data or units directly
            });
        }
    }

    

    generateLabels = () => {
       

        return this.props.data.map(x => {
          
            const date = moment(x.date, 'DD/MM/YYYY mm:hh:ss');
         
            const dateout = date.format(this.props.dateFormat || "MMM YYYY");
        

            if(dateout === 'Invalid date')//Incositencys in data set breaking one graph or the other. Painful. 
            {
                const date = moment(new Date(x.date));
                return date.format(this.props.dateFormat || "MMM YYYY");
            }

            return dateout
        });
    }

    generateConsumptionDataset() {

        
        if (this.props.data && this.props.data.length > 0)
        {

        if (Object.keys(this.props.data[0]).filter(e => e.toLowerCase() === 'query').length > 0) {
            return this.props.units.map(x => createLineDataSetFrom(this.props.data, x.field, x.label, x.color));
          }

        return [
            createLineDataSetFrom(this.props.data, "gas", "Gas", UtilityColors.gas),
            createLineDataSetFrom(this.props.data, "electricity", "Electricity", UtilityColors.electricity),
            createLineDataSetFrom(this.props.data, "water", "Water", UtilityColors.water),
        ];

    }else return [];
    }

    generateConsumptionOptions() {
        return {
            maintainAspectRatio: false,
            scales: {
                yAxes: [
                    {
                        type: 'linear',
                        position: 'left',

                        scaleLabel: {
                            display: this.props.size === "compress" ? false : true,
                            labelString: this.props.label || "",
                            fontStyle: "bold"

                        },
                        gridLines: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                        ticks: {
                            beginAtZero: true,
                            userCallback: function(value, index, values) {
                                return value.toLocaleString();   // this is all we need
                            },
                            fontSize: this.props.size === "compress" ? 9 : 12 // Change font size based on size prop
                        },
                    }
                ],
                xAxes: [
                    {
                        ticks: {
                            fontSize: this.props.size === "compress" ? 9 : 12 // Change font size based on size prop
                        }
                    }
                ]
            },
            hover: {
                intersect: true,
                mode: 'nearest',
            },

            
            legend: {
                position: 'bottom',
                display : this.props.size === "compress" ? false : true
            },
            title: {
                text: this.props.title || "Monthly Unit Chart",
                display: true,
                fontSize: this.props.size === "compress" ? 9 : 13
            },
            // Add onClick event handler for navigation
            onClick:  ((evt, element) => {
                

                if (element.length > 0) {
                    
                    if (this.props.onElementsClick) {
                        this.props.onElementsClick(evt, element);
                        return;
                    }

                 

                    const firstPoint = element[0]._chart.getElementAtEvent(evt)[0];

                    const datasetIndex = firstPoint._datasetIndex;
                    const index = firstPoint._index;
                    const datasetLabel = this.state.datasets[datasetIndex].label;
                    const date = this.props.data[index].date;
    
                    // Format the date and construct query parameters
                    var queryParams = new URLSearchParams({
                      date: moment(date).format("YYYY-MM-DD"),
                      utility: datasetLabel.toLowerCase(),
                    }).toString();
                    var url = `/supplier-invoices?${queryParams}`;
    

                    if(this.props.selectedRowKey && this.props.selectedRowKey !== '' && this.props.selectedRowKey !== 'undefined')
                    {

                         queryParams = new URLSearchParams({
                            siteKey : this.props.selectedRowKey,
                            utility: datasetLabel.toLowerCase(),
                            tab : "supplier-invoices",
                            date: moment(date).format("YYYY-MM-DD")
            
                          }).toString();
                        url = `/site?${queryParams}`;
            

                    }
                    console.log(queryParams)    
                    // Use React Router's history object to navigate
                    setTimeout(() => {

                    this.props.history.push(url);
                    },10 * 60)
                }else
                {
                }

                
            }),
           
        };
    }

    render() {

        const afterDatasetsDrawPlugin = {
            afterDatasetsDraw: chart => {
                if (this.state.initialSetupDone) return;

                const defaultUtility = this.props.defaultUtility;
                if (defaultUtility) {
                    let foundMatch = false;
                    chart.data.datasets.forEach((dataset, index) => {
                        if (dataset.label.toLowerCase() === defaultUtility.toLowerCase()) {
                            foundMatch = true;
                        } else {
                            const meta = chart.getDatasetMeta(index);
                            meta.hidden = true;
                        }
                    });
            
                    // If no matching default utility is found, show all datasets
                    if (!foundMatch) {
                        chart.data.datasets.forEach((dataset, index) => {
                            const meta = chart.getDatasetMeta(index);
                            meta.hidden = false;
                        });
                    }
            
                    chart.update();
                    this.setState({ initialSetupDone: true }); // Set the flag after initial setup
                                }
            }
            
        }

        return (<UnitChart datasets={this.state.datasets} labels={this.state.labels}
            onElementsClick={this.props.onElementsClick} // Pass the callback function here
            options={this.state.options} isLoading={this.props.isLoading} size={this.props.size}
            plugins={[afterDatasetsDrawPlugin]} />)
    }
}

MonthlyUnitLineChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        date: PropTypes.any.isRequired
    })),
    units: PropTypes.arrayOf(PropTypes.shape({
        field: PropTypes.string.isRequired,
        label: PropTypes.string,
        color: PropTypes.string,
    })),
    dateFormat: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.string,
    isLoading: PropTypes.bool,
    size: PropTypes.oneOf(["small", "compress", "medium", "large"]),
    defaultUtility: PropTypes.string 
};

export default withRouter(MonthlyUnitLineChart);